var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKofrika(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 797,
    height: 250,
    viewBox: "0 0 797 250",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_601_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.711 203.07L300.391 200.62L296.201 143.09H318.681V109.31H293.741L291.751 82.05L314.991 80.87L314.291 97.22L348.031 98.67L350.331 45.25L255.561 50.08L266.711 203.07Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.02 232.8L225.78 23.7702L379.41 15.9502L374.6 127.62L346.47 126.41V170.87H326.08L330.12 226.31L241.02 232.8Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.48 108.71L457.21 45.25L362.43 50.08L373.58 203.07L407.27 200.61L403.47 148.47L435.79 159.92L428.91 198.56L462.16 204.49L474.07 137.65L428.36 121.46L454.48 108.71ZM429.9 85.72L400.2 102.16L398.64 77.81L430.28 75.98L429.9 85.72Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.64 236.71L429.36 226.86L347.9 232.8L332.66 23.7702L486.28 15.9502L482.19 111.05L505.56 119.33L484.64 236.71Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 62.24L116.92 39.27L66.6905 93.37L63.4205 48.45L29.7305 50.9L40.8205 203.07L74.5105 200.62L70.0505 139.41L75.2205 133.83L100.59 144.01L92.4805 198.94L125.9 203.88L137.89 122.59L99.8305 107.32L141.67 62.24Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33 235.42L93.09 227.12L15.13 232.8L0 25.21L89.11 18.72L89.76 27.68L115.45 0L180.94 60.78L147.7 96.59L168.58 104.97L149.33 235.42Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.47 62.24L622.72 39.27L572.49 93.37L569.22 48.45L535.53 50.9L546.62 203.07L580.31 200.62L575.85 139.41L581.02 133.83L606.39 144.01L598.28 198.94L631.7 203.88L643.69 122.59L605.63 107.32L647.47 62.24Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.13 235.42L598.89 227.12L520.93 232.8L505.8 25.21L594.91 18.72L595.56 27.68L621.25 0L686.74 60.78L653.5 96.59L674.38 104.97L655.13 235.42Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.798 49.981L477.052 51.5146L483.918 202.603L517.664 201.07L510.798 49.981Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.278 20.9601L448.027 25.0161L457.417 231.619L546.667 227.563L537.278 20.9601Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.72 169.36V79.2798L702.6 45.0698L652.14 91.8398L665.08 163.68L645.78 192.43L673.83 211.25L700.75 171.14L696.81 149.25L725.96 140.05V203.13H768.42V169.35H759.72V169.36ZM690.76 115.74L688.65 104.04L706.97 87.0598L725.94 98.4198V104.63L690.76 115.74Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.42 249.81L607.23 200.02L635.74 157.54L622.1 81.7998L699 10.5298L787.51 63.5398V141.58H796.19V230.92H698.16V224.86L681.42 249.81Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.92 45.0698L139.4 91.8898L156.08 181.31L201.04 206.23L247.03 173.98V79.2798L189.92 45.0698ZM193.22 189.81L195.08 137.68L178.92 112.58L202.51 70.0198L195.63 111.65L212.13 138.03L193.22 189.81Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42 217.69L131.17 199.27L109.28 81.9198L186.32 10.5298L199.37 18.3498L235.61 40.0498L274.82 63.5398V188.43L205.58 236.98L164.42 217.69Z",
    fill: "#0E1522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.711 203.07L300.391 200.62L296.201 143.09H318.681V109.31H293.741L291.751 82.05L314.991 80.87L314.291 97.22L348.031 98.67L350.331 45.25L255.561 50.08L266.711 203.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.481 108.71L457.211 45.25L362.431 50.08L373.581 203.07L407.271 200.61L403.471 148.47L435.791 159.92L428.911 198.56L462.161 204.49L474.071 137.65L428.361 121.46L454.481 108.71ZM429.901 85.72L400.201 102.16L398.641 77.81L430.281 75.98L429.901 85.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 62.24L116.92 39.27L66.6905 93.37L63.4205 48.45L29.7305 50.9L40.8205 203.07L74.5105 200.62L70.0505 139.41L75.2205 133.83L100.59 144.01L92.4805 198.94L125.9 203.88L137.89 122.59L99.8305 107.32L141.67 62.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.47 62.24L622.72 39.27L572.49 93.37L569.22 48.45L535.53 50.9L546.62 203.07L580.31 200.62L575.85 139.41L581.02 133.83L606.39 144.01L598.28 198.94L631.7 203.88L643.69 122.59L605.63 107.32L647.47 62.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.798 49.9815L477.052 51.5151L483.918 202.604L517.664 201.07L510.798 49.9815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.72 169.36V79.2798L702.6 45.0698L652.14 91.8398L665.08 163.68L645.78 192.43L673.83 211.25L700.75 171.14L696.81 149.25L725.96 140.05V203.13H768.42V169.35H759.72V169.36ZM690.76 115.74L688.65 104.04L706.97 87.0598L725.94 98.4198V104.63L690.76 115.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.92 45.0698L139.4 91.8898L156.08 181.31L201.04 206.23L247.03 173.98V79.2798L189.92 45.0698ZM193.22 189.81L195.08 137.68L178.92 112.58L202.51 70.0198L195.63 111.65L212.13 138.03L193.22 189.81Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 796.19,
    height: 249.81,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKofrika);
export default __webpack_public_path__ + "static/media/kofrika.5e2a476bd2638383c79deade089307a4.svg";
export { ForwardRef as ReactComponent };